/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  const CART_STATE_CONFIGURED_STORAGE_KEY = "CART_STATE_CONFIGURED_STORAGE_KEY";

  /**
   * Renewal checkout gate: when a stylist has a Kit (renewal) product in her
   * cart, show a non-dismissable modal forcing her to either complete checkout
   * or clear the cart entirely (line items + cart attributes + cart note).
   */
  function showKitCheckoutModal() {
    const modal = document.getElementById('kit-checkout-modal');
    if (!modal || !window.MicroModal) return;

    window.MicroModal.show('kit-checkout-modal', {
      disableScroll: true,
      disableFocus: false,
      awaitCloseAnimation: false,
      onClose: function () {
        setTimeout(function () {
          window.MicroModal.show('kit-checkout-modal', { disableScroll: true });
        }, 0);
      },
    });
  }

  async function clearKitCart() {
    const cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';

    const cart = await fetch(`${cartUrl}.js?t=${Date.now()}`).then((res) => res.json());

    const attributes = {};
    if (cart.attributes) {
      Object.keys(cart.attributes).forEach((key) => { attributes[key] = ''; });
    }

    const updates = {};
    (cart.items || []).forEach((item) => { updates[item.key] = 0; });

    await fetch(`${cartUrl}/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, attributes, note: '' }),
    });
  }

  function initKitCheckoutGate() {
    if (!window.cartHasKit) return;

    const modal = document.getElementById('kit-checkout-modal');
    if (!modal) return;

    const checkoutBtn = modal.querySelector('[data-kit-checkout]');
    const clearBtn = modal.querySelector('[data-kit-clear]');

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        checkoutBtn.disabled = true;
        if (clearBtn) clearBtn.disabled = true;
        if (typeof window.customCheckout === 'function') {
          window.customCheckout();
        } else {
          window.location.href = '/checkout';
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', async function () {
        clearBtn.disabled = true;
        if (checkoutBtn) checkoutBtn.disabled = true;
        try {
          await clearKitCart();
        } catch (err) {
          console.error('Failed to clear renewal cart:', err);
        }
        window.location.reload();
      });
    }

    showKitCheckoutModal();
  }

  document.addEventListener('DOMContentLoaded', initKitCheckoutGate);

  // Function to format date to "Month DD, YYYY"
  // Parses date string directly to avoid timezone issues
  function formatPromisedByDate(dateString) {
    if (!dateString) {
      return null;
    }

    // Extract date part (YYYY-MM-DD) - works for both "2026-01-25" and "2026-01-25T00:00:00Z"
    const datePart = dateString.slice(0, 10);
    const [year, month, day] = datePart.split('-').map(Number);

    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      return null;
    }

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${monthNames[month - 1]} ${day}, ${year}`;
  }

  /*
   * Back order / pre-order ship date message on the PDP.
   *
   * Both states share one message component (.product__submit__promised_by, rendered
   * by snippets/product-buttons.liquid): same placement, same styling, only the copy
   * and the date differ. A product can be both at once and only ever one message
   * shows - the later date wins, and a tie goes to pre-order - the same rule
   * snippets/cart-line-items.liquid applies in the cart.
   *
   * Which message wins changes nothing about what is added to the cart: _backordered
   * and _promised_by are still stamped whenever the variant is genuinely backordered,
   * and _preorder is stamped in Liquid by snippets/preorder-line-item-property.liquid.
   */

  // Product-level, written by snippets/preorder-ship-date.liquid, and present only
  // while the date is still in the future. Always a 10-character YYYY-MM-DD.
  function getPreorderShipDate(display) {
    const shipDate = (display && display.dataset.preorderShipDate) || "";
    return shipDate.length === 10 ? shipDate : "";
  }

  // CAB-3672: the answer lives in snippets/product-buttons.liquid, not here.
  function preorderPaintsBeforeVariantSelection(display) {
    return Boolean(display) && display.dataset.preorderBeforeVariantSelection === "true";
  }

  // Compare as YYYYMMDD numbers so the tiebreaker never depends on string comparison,
  // matching snippets/preorder-ship-date.liquid. Handles both "2026-01-25" and
  // "2026-01-25T00:00:00Z". Returns null for anything that is not a usable date.
  function shipDateNumber(dateString) {
    if (!dateString) {
      return null;
    }

    const number = Number(String(dateString).slice(0, 10).replace(/-/g, ""));
    return Number.isNaN(number) || number === 0 ? null : number;
  }

  /*
   * The single "which message does this product show?" rule: the later date wins and
   * a tie goes to pre-order. Returns "preorder", "backorder", or "" when neither
   * state applies. Mirrors the same comparison snippets/cart-line-items.liquid makes.
   */
  function chooseShipDateMessage(preorderShipDate, promisedByDate) {
    if (!preorderShipDate) {
      return promisedByDate ? "backorder" : "";
    }

    if (!promisedByDate) {
      return "preorder";
    }

    const preorderNumber = shipDateNumber(preorderShipDate);
    const promisedNumber = shipDateNumber(promisedByDate);

    // An unreadable back order date leaves the pre-order date - which Liquid
    // guarantees is a real YYYY-MM-DD - as the only one worth comparing, and a
    // pre-order date we somehow cannot read leaves the back order date.
    if (preorderNumber === null || promisedNumber === null) {
      return preorderNumber === null ? "backorder" : "preorder";
    }

    return preorderNumber >= promisedNumber ? "preorder" : "backorder";
  }

  function showShipDateMessage(display, template, dateString) {
    const messageEl = display.querySelector("[data-promised-by]");
    if (!messageEl || !template) {
      return;
    }

    const formattedDate = formatPromisedByDate(dateString) || String(dateString).split("T")[0];
    messageEl.textContent = template.replace("[DATE]", formattedDate);
    display.classList.add("is-visible");
  }

  function showPreorderMessage(display, shipDate) {
    const messageEl = display.querySelector("[data-promised-by]");
    showShipDateMessage(display, messageEl && messageEl.dataset.preorderMessage, shipDate);
  }

  function showBackorderMessage(display, promisedByDate) {
    const messageEl = display.querySelector("[data-promised-by]");
    showShipDateMessage(display, messageEl && messageEl.dataset.promisedBy, promisedByDate);
  }

  document.addEventListener("theme:variant:change", async function (event) {
    const { variant } = event.detail;
    const submitBtns = document.querySelector(".product__submit__buttons");
    const formWrapper = submitBtns.closest('product-form');
    const backorderedProp = submitBtns.querySelector("input[name='properties[_backordered]']");
    const promisedByProp = submitBtns.querySelector("input[name='properties[_promised_by]']");
    const promisedByDisplay = submitBtns.querySelector(".product__submit__promised_by");
    const saleProp = submitBtns.querySelector("input[name='properties[_sale]']");
    const preorderShipDate = getPreorderShipDate(promisedByDisplay);

    Promise.all([
      backorderedProp && backorderedProp.remove(),
      promisedByProp && promisedByProp.remove(),
      saleProp && saleProp.remove(),
    ]);

    /*
     * Reset the message to this page's baseline before the lookup goes out. When the
     * pre-order message paints ahead of variant selection it stays up while the back
     * order lookup is in flight, so it never blinks off and on; otherwise nothing
     * shows until the lookup answers, the way back order has always behaved.
     */
    if (promisedByDisplay) {
      if (preorderShipDate && preorderPaintsBeforeVariantSelection(promisedByDisplay)) {
        showPreorderMessage(promisedByDisplay, preorderShipDate);
      } else {
        promisedByDisplay.classList.remove("is-visible");
      }
    }

    if (variant) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const saleInput = document.createElement("input");
        saleInput.type = "hidden";
        saleInput.name = "properties[_sale]";
        saleInput.value = "true";
        submitBtns.appendChild(saleInput);
      }

      const inventoryData = await window.backend.getInventoryPromisedBy(variant.id);
      const promisedByDate =
        inventoryData && inventoryData.is_backordered && inventoryData.promised_by
          ? inventoryData.promised_by
          : "";

      if (promisedByDate) {
        const boInput = document.createElement("input");
        boInput.type = "hidden";
        boInput.name = "properties[_backordered]";
        boInput.value = "true";
        submitBtns.appendChild(boInput);

        const pbInput = document.createElement("input");
        pbInput.type = "hidden";
        pbInput.name = "properties[_promised_by]";
        pbInput.value = promisedByDate;
        submitBtns.appendChild(pbInput);
      }

      if (!promisedByDisplay) {
        return;
      }

      const message = chooseShipDateMessage(preorderShipDate, promisedByDate);

      if (message === "preorder") {
        showPreorderMessage(promisedByDisplay, preorderShipDate);
      } else if (message === "backorder") {
        showBackorderMessage(promisedByDisplay, promisedByDate);
      } else {
        promisedByDisplay.classList.remove("is-visible");
      }
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log("Cart ———————————— ↓");
      console.log(cart);
      // ... update an app or a custom shipping caluclator
      const storedCartStateConfigured = sessionStorage.getItem(CART_STATE_CONFIGURED_STORAGE_KEY);
      if (storedCartStateConfigured) sessionStorage.removeItem(CART_STATE_CONFIGURED_STORAGE_KEY);
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    console.log("theme:cart:init");
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener("theme:scroll", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:up", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:down", (e) => {
    console.log(e);
  });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  async function configureCartState() {
    try {
      const storedCartStateConfigured = sessionStorage.getItem(CART_STATE_CONFIGURED_STORAGE_KEY);
      if (storedCartStateConfigured) return;

      const cart = await fetch(`${window.theme.routes.cart}.js?t=${Date.now()}`).then((res) => res.json());
      const foundEnrollmentItems = cart.items.filter((item) => item.properties?._set === "enrollment");

      if (foundEnrollmentItems.length) {
        let data = {};
        data = foundEnrollmentItems.reduce((obj, item) => {
          obj[item.key] = 0;
          return obj;
        }, {});
        await removeFromCart(data);
      }
      sessionStorage.setItem(CART_STATE_CONFIGURED_STORAGE_KEY, Date.now());
    } catch (e) {
      console.warn(e);
    }
  }

  async function removeFromCart(data) {
    return window
      .fetch(`${window.theme.routes.cart}/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: data }),
      })
      .then((res) => res.json())
      .then((res) => {
        if (!res.items) {
          throw new Error("There was a problem updating the cart.");
        }
        document.dispatchEvent(
          new CustomEvent("theme:cart:init", {
            bubbles: true,
          })
        );
      })
      .catch((err) => {
        console.error(err);
      });
  }

  document.addEventListener("DOMContentLoaded", configureCartState);

  // Partner display handler
  document.addEventListener("theme:partner:render", function (event) {
    const partner = event.detail?.partner;

    // Update elements with data-showon-partner attribute
    document.querySelectorAll("[data-showon-partner]").forEach((el) => {
      if (partner) {
        el.classList.remove("d-none");
      } else {
        el.classList.add("d-none");
      }
    });

    // Update elements with data-hideon-partner attribute
    document.querySelectorAll("[data-hideon-partner]").forEach((el) => {
      if (partner) {
        el.classList.add("d-none");
      } else {
        el.classList.remove("d-none");
      }
    });

    // Show attribution must take display precedence over stylist attribution: it
    // is the harder-to-notice, harder-to-leave state, and a shopper who does not
    // realise they are in a show cannot choose to leave it (CAB-3517).
    //
    // The show suffix is keyed off CURRENT_SHOW_ID rather than the hostess name so
    // the banner tracks real attribution even when a hostess name is missing, and
    // it is now un-hidden AND re-hidden — previously it was only ever un-hidden,
    // so it survived on screen after the show had been cleared.
    const activeShowId = localStorage.getItem("CURRENT_SHOW_ID");
    const isShoppingUnderShow = !!activeShowId;
    const showHostessName = localStorage.getItem("CURRENT_SHOW_HOSTESS_NAME");

    document.querySelectorAll("[data-partner-show-extra]").forEach((el) => {
      el.classList.toggle("d-none", !isShoppingUnderShow);
    });

    // Exit-show affordance: only meaningful while a show is actually attached.
    document.querySelectorAll("[data-exit-show]").forEach((el) => {
      el.hidden = !isShoppingUnderShow;
    });

    // Two different names live behind [data-partner-name], so the hostess is
    // opt-in per element rather than applied to all of them:
    //
    //   - The header sentence is possessive about the SHOW ("You Are Shopping
    //     With <name>'s show"), so it wants the hostess who owns it. It opts in
    //     with data-partner-name-prefer-show, and falls back to the stylist
    //     outside a show, where the "'s show" suffix is hidden anyway.
    //   - Everything else — notably the partner-modal.liquid heading sitting
    //     under the "Your Stylist" label — wants the attributed STYLIST, the one
    //     window.partner resolved and the one checkout receives as
    //     attributes[StylistID]. Overriding that with the hostess is what made
    //     the modal read "Your Stylist - <hostess>" (CAB-3516 QA).
    if (partner) {
      const partnerName = (partner.firstName || partner.siteName || "").trim();
      const hostessName = (showHostessName || "").trim();
      document.querySelectorAll("[data-partner-name]").forEach((el) => {
        const preferShowHostess = el.hasAttribute("data-partner-name-prefer-show");
        el.textContent = preferShowHostess && isShoppingUnderShow && hostessName ? hostessName : partnerName;
      });
    }

    // Handle show mode UI changes (isShoppingUnderShow is computed above)
    // Update role label (Your Stylist vs Your Hostess)
    document.querySelectorAll("[data-partner-role-label]").forEach((el) => {
      if (isShoppingUnderShow) {
        el.textContent = el.dataset.hostessText || "Your Hostess";
      } else {
        el.textContent = el.dataset.stylistText || "Your Stylist";
      }
    });

    // Hide/show elements based on show mode
    document.querySelectorAll("[data-hideon-show]").forEach((el) => {
      if (isShoppingUnderShow) {
        el.style.display = "none";
      } else {
        el.style.display = "";
      }
    });

    // Add show-mode class to partner modal for layout adjustments
    const partnerModal = document.querySelector(".partner-modal__container");
    if (partnerModal) {
      if (isShoppingUnderShow) {
        partnerModal.classList.add("partner-modal--show-mode");
      } else {
        partnerModal.classList.remove("partner-modal--show-mode");
      }
    }
  });

  // Remove consultant handler
  document.addEventListener("DOMContentLoaded", function() {
    const removeConsultantLink = document.querySelector('[data-remove-consultant]');
    
    if (removeConsultantLink) {
      removeConsultantLink.addEventListener('click', function(e) {
        e.preventDefault();
        
        window.closeModalManually('info-partner');

        // Persist the opt-out, exactly as "Continue Without Stylist" does
        // (partner-selector.liquid#writeOptOut - keep the key and record shape in
        // step). The clears below only empty the CURRENT_* keys, so the next page
        // load found no current stylist, fell back to the preferred-stylist
        // metafield and put that stylist straight back (CAB-3917).
        // attribution.js withholds metafield-driven attribution while this stands.
        try {
          localStorage.setItem('STYLIST_OPT_OUT', JSON.stringify({ value: true, expires: Date.now() + 24 * 60 * 60 * 1000 }));
        } catch (err) {
          window.logExceptionToSentry?.(err, { context: 'remove consultant: write opt-out' });
        }

        // Clear attribution data from localStorage
        localStorage.removeItem('CURRENT_SITE');
        localStorage.removeItem('CURRENT_SHOW_ID');
        localStorage.removeItem('CURRENT_SHOW_SITE');
        localStorage.removeItem('CURRENT_SHOW_NAME');
        localStorage.removeItem('CURRENT_SHOW_HOSTESS_NAME');
        localStorage.removeItem('CURRENT_STYLIST_ID');
        localStorage.removeItem('CURRENT_STYLIST_TYPE');
        localStorage.removeItem('CURRENT_SHOW_EVENT_IDS');
        localStorage.removeItem('CURRENT_ATTRIBUTION_SOURCE');
        localStorage.removeItem('CURRENT_ATTRIBUTION_SET_AT');
        localStorage.removeItem('CURRENT_ATTRIBUTED_SITE_STAMP');

        // Clear attribution data from sessionStorage
        sessionStorage.removeItem('PREFERRED_SITE');
        
        // Clear URL parameters
        const url = new URL(window.location);
        url.searchParams.delete('pws');
        url.searchParams.delete('show');
        window.history.replaceState({}, '', url.toString());
        
        // Clear the global partner object
        window.partner = null;

        // The checkout extension reads StylistID from the cart attributes, which
        // the clears above do not touch. Forced, as in continueWithoutStylist.
        window.clearStylistCartAttributes?.({ force: true });

        // Dispatch event to update UI
        document.dispatchEvent(new CustomEvent('theme:partner:render', { 
          detail: { partner: null } 
        }));
        
        console.log('Consultant removed and attribution cleared');
      });
    }

    // "Change Stylist" — close info-partner, then open the finder, in that order.
    // The link used to carry data-micromodal-close AND data-popup-partner, so a
    // single tap opened the finder and then ran info-partner's close handlers.
    // Those strip the body scroll lock, remove the focus trap the finder had just
    // installed, and force focus back to the header trigger. Open modals are
    // position:absolute (theme.css .micromodal-slide.is-open), so on a page
    // scrolled away from the top — the normal case on a phone — the finder ended
    // up rendered off-screen and the tap looked like it just closed the popup.
    //
    // Dispatching theme:partner:find routes through the finder's own
    // openFindYourConsultantModal(), the same path "Find A New Stylist" uses, so
    // its isModalOpen guard stays honest too; the old trigger bypassed both.
    const changeStylistLink = document.querySelector('[data-change-stylist]');
    if (changeStylistLink) {
      changeStylistLink.addEventListener('click', function (e) {
        console.log("changeStylistLink clicked");
        e.preventDefault();
        window.closeModalManually('info-partner');
        document.dispatchEvent(new CustomEvent('theme:partner:find'));
      });
    }

    // Leave-this-show handler (CAB-3516). Clears show state and re-loads so
    // attribution re-resolves cleanly onto the show stylist's own PWS — the
    // shopper leaves the show without losing their stylist altogether.
    const exitShowLink = document.querySelector('[data-exit-show]');
    if (exitShowLink) {
      exitShowLink.addEventListener('click', function (e) {
        e.preventDefault();

        if (typeof window.attributionExitShow !== 'function') {
          window.logToSentry?.('attributionExitShow unavailable when exiting show', 'error');
          return;
        }

        const { showSite } = window.attributionExitShow();
        window.closeModalManually('info-partner');

        // Land on the show stylist's PWS if known, otherwise just drop the show.
        const url = new URL(window.location);
        url.searchParams.delete('show');
        if (showSite) url.searchParams.set('pws', showSite);
        location.replace(url.toString());
      });
    }
  });

  // "Your Stylist" (info-partner) modal — MicroModal-independent close controls.
  // Bind info-partner's close controls directly here too, via closeModalManually,
  // so they work regardless of what is stacked over it. This mirrors MicroModal's
  // own onClick semantics (close only when the clicked element itself carries
  // data-micromodal-close) and its ESC handling, but is not tied to the single
  // activeModal reference.
  document.addEventListener('DOMContentLoaded', function () {
    const infoPartner = document.getElementById('info-partner');
    if (!infoPartner) return;

    function isInfoPartnerOpen() {
      return infoPartner.classList.contains('is-open');
    }

    // The X button and the overlay backdrop carry data-micromodal-close. Match
    // MicroModal: act only when the click target itself has the attribute, so
    // clicks inside the modal content (a descendant of the data-micromodal-close
    // overlay) don't accidentally close it.
    // "Change Stylist" is deliberately NOT one of them — it closes and opens in a
    // defined order through its own handler above.
    infoPartner.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-micromodal-close') && window.closeModalManually) {
        window.closeModalManually('info-partner');
      }
    });

    // ESC closes info-partner, but don't steal it from a modal stacked on top:
    // while more than one modal is open, let the topmost one handle ESC first.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;
      if (!isInfoPartnerOpen()) return;
      const openModals = document.querySelectorAll('.modal.micromodal-slide.is-open');
      if (openModals.length > 1) return;
      if (window.closeModalManually) window.closeModalManually('info-partner');
    });
  });

  // Intercept checkout button clicks to use custom checkout
  function interceptCheckoutSubmission() {
    // Track checkout button clicks via click listener for broad browser compatibility
    // (e.submitter is not supported in Safari < 15.4)
    let checkoutClicked = false;

    document.addEventListener("click", function (e) {
      const btn = e.target.closest('[name="checkout"], button[name="checkout"]');
      checkoutClicked = !!btn;
    }, true);

    document.addEventListener("submit", function (e) {
      // Check if this is a cart form
      const form = e.target;
      if (!form.matches('[data-cart-form], form[action*="/cart"]')) return;

      // Check if the checkout button was the trigger
      // Use e.submitter when available, fall back to click flag
      const isCheckout = (e.submitter && e.submitter.name === "checkout") || checkoutClicked;
      checkoutClicked = false;

      if (!isCheckout) return;

      // Prevent default checkout flow
      e.preventDefault();

      // Use custom checkout with context injection
      if (typeof window.customCheckout === "function") {
        console.log("Using custom checkout with context injection");
        window.customCheckout();
      } else {
        console.error("window.customCheckout is not defined");
        // Fallback to normal submission if needed
        form.submit();
      }
    });
  }

  // Initialize checkout interception on DOM ready
  document.addEventListener("DOMContentLoaded", interceptCheckoutSubmission);

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
